import { MutationHookOptions, useMutation } from '@apollo/client';

import { REMOVE_USER } from './mutations';

export const useDeleteUser = (options?: MutationHookOptions) => useMutation(REMOVE_USER, options);
